import type { QueryClient } from "@tanstack/react-query";

export const PROXY_ASYNC_REFRESH_DELAYS_MS = [1500, 5000];

export function refreshProxyQueries(
  queryClient: QueryClient,
  agentID?: string,
  options: { includeProfiles?: boolean; delayed?: boolean } = {},
) {
  const trimmedAgentID = agentID?.trim();
  if (options.includeProfiles) {
    void queryClient.invalidateQueries({ queryKey: ["proxy-profiles"] });
  }
  void queryClient.invalidateQueries({ queryKey: ["machine"] });
  void queryClient.invalidateQueries({ queryKey: ["launch-slots"] });
  void queryClient.invalidateQueries({ queryKey: ["role-launch-bindings"] });
  void queryClient.invalidateQueries({ queryKey: ["launch-jobs"] });
  void queryClient.invalidateQueries({ queryKey: ["agent-sing-box-state"] });
  void queryClient.invalidateQueries({ queryKey: ["agent-sing-box-plan"] });
  void queryClient.invalidateQueries({ queryKey: ["agent-sing-box-history"] });
  void queryClient.invalidateQueries({ queryKey: ["agent-sing-box-versions"] });
  if (trimmedAgentID) {
    void queryClient.invalidateQueries({
      queryKey: ["launch-slots", trimmedAgentID],
    });
    void queryClient.invalidateQueries({
      queryKey: ["agent-sing-box-state", trimmedAgentID],
    });
    void queryClient.invalidateQueries({
      queryKey: ["agent-sing-box-plan", trimmedAgentID],
    });
    void queryClient.invalidateQueries({
      queryKey: ["agent-sing-box-history", trimmedAgentID],
    });
    void queryClient.invalidateQueries({
      queryKey: ["agent-sing-box-versions", trimmedAgentID],
    });
  }
  if (options.delayed) {
    for (const delay of PROXY_ASYNC_REFRESH_DELAYS_MS) {
      window.setTimeout(() => {
        refreshProxyQueries(queryClient, trimmedAgentID, {
          includeProfiles: options.includeProfiles,
          delayed: false,
        });
      }, delay);
    }
  }
}
